<template>
  <section class="section">
    <div class="container">
      <TituloPrincipal
        :titulo="titulo"
        :subtitulo="subtitulo"
      />
      <b-table
        v-if="data.length > 0"
        :data="data"
        :loading="loading"
        paginated
        backend-pagination
        :total="total"
        :per-page="perPage"
        @page-change="onPageChange"
      >
        <template slot-scope="props">
          <b-table-column
            label=""
            :width="10"
            stripped
          >
            <b-tooltip
              label="Ver Detalle"
              type="is-light"
            >
              <b-button
                type="is-primary"
                :loading="loading"
                target='_blank'
                @click="verPedido(props.row.id)"
                icon-left="magnify"
              ></b-button>
            </b-tooltip>
          </b-table-column>

          <b-table-column
            field="id"
            label="ID"
            :width="70"
          >{{ props.row.id }}</b-table-column>
          <b-table-column
            field="tipo"
            label="Tipo"
          >
            <b-taglist attached>
              <b-tag :type="esCompraOnline(props.row.tipo) ? 'is-info' : ''">
                {{ esCompraOnline(props.row.tipo) ? 'COMPRA ONLINE' : 'TRADICIONAL' }}
              </b-tag>
              <b-tag v-if="esCompraOnline(props.row.tipo)">
                <img
                  height="24"
                  width="24"
                  src="@/assets/img/mp/isologo_mp.png"
                >
              </b-tag>
              <b-tag v-if="props.row.tipo === $constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO.textoEntidad">
                <b-tooltip :label="$constantes.pedidos.tiposEntrega.ENVIO_DOMICILIO.texto">
                  <b-icon icon="motorbike"></b-icon>
                </b-tooltip>
              </b-tag>
              <b-tag v-if="props.row.tipo === $constantes.pedidos.tipos.COMPRA_ONLINE_CON_MERCADO_ENVIOS.textoEntidad">
                <b-tooltip :label="$constantes.pedidos.tiposEntrega.ENVIO_RESTO_DEL_PAIS.texto">
                  <b-icon icon="truck-delivery"></b-icon>
                </b-tooltip>
              </b-tag>
              <b-tag
                v-if="props.row.tipo === $constantes.pedidos.tipos.COMPRA_ONLINE.textoEntidad"
              >
                <b-tooltip :label="$constantes.pedidos.tiposEntrega.RETIRO_LOCAL.texto">
                  <b-icon icon="home"></b-icon>
                </b-tooltip>
              </b-tag>
            </b-taglist>
          </b-table-column>

          <b-table-column
            field="fechaemision"
            label="Fecha Emisión"
            :width="230"
            centered
          ><span class="tag is-success">{{ props.row.fechaEmision ? new Date(props.row.fechaEmision).toLocaleDateString() : '' }}</span></b-table-column>

          <b-table-column
            field="estado"
            label="Estado"
            :width="230"
          >
            <span
              v-bind:class="{ 'is-success': props.row.estado === constantes.pedidos.estados.CARGANDO,
                              'is-danger': props.row.estado === constantes.pedidos.estados.CREADO,
                              'is-link': props.row.estado === constantes.pedidos.estados.PENDIENTE_PAGO,
                              'is-warning': props.row.estado === constantes.pedidos.estados.ENVIO_PENDIENTE,
                              'is-light': props.row.estado === constantes.pedidos.estados.PARA_RETIRO,
                              'is-info': props.row.estado === constantes.pedidos.estados.PROCESANDO,
                              'is-primary': props.row.estado === constantes.pedidos.estados.CERRADO }"
              class="tag"
            >{{ props.row.estado | eliminarGuionesBajos }}</span>
          </b-table-column>
          <b-table-column
            field="nombreCompleto"
            label="Producto"
          >{{ props.row.nombreCompleto }} <strong>({{props.row.cantidadFotos}})</strong>
          </b-table-column>
          <b-table-column
            field="precio"
            label="Precio"
          >${{ props.row.precio }}</b-table-column>
        </template>
      </b-table>
      <div
        v-if="data.length === 0 && !loading"
        class="box"
      >
        <b-message type="is-primary">
          ¿Todavía no subiste tu primer pedido? Hacé <router-link :to="{name: 'subir-fotos'}"><strong>clic acá</strong></router-link>, guarda esos momentos para siempre
        </b-message>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

import TituloPrincipal from '@/components/TituloPrincipal.vue'

export default {
  data () {
    return {
      titulo: 'Pedidos',
      subtitulo: 'Listado de pedidos procesados por nuestro sitio web.',
      data: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
      constantes: this.$constantes
    }
  },
  components: {
    TituloPrincipal
  },
  methods: {
    esCompraOnline (tipoPedido) {
      let esCompraOnline = true
      if (tipoPedido === this.$constantes.pedidos.tipos.TRADICIONAL.textoEntidad) {
        esCompraOnline = false
      }
      return esCompraOnline
    },
    verPedido (id) {
      this.$router.push({ name: 'pedido-estado', params: { id } })
    },
    /*
     * Recupera los pedidos asincronicamente
     */
    recuperarPedidos () {
      this.loading = true
      var componenteVue = this
      var username = this.$VueJwtDecode.decode(localStorage.getItem('jwt')).username

      function postGetPedidosUser (error, data) {
        if (error) {
          this.mensajeErrorAxios(error, componenteVue)
        } else {
          componenteVue.data = data['hydra:member']
          componenteVue.total = data['hydra:totalItems']
          componenteVue.loading = false
        }
      }
      this.$apiService.getPedidosUser(this.perPage, this.page, username, postGetPedidosUser)
    },
    /*
     * Maneja el paginado cuando cambia de pagina
     */
    onPageChange (page) {
      this.page = page
      this.recuperarPedidos()
    }
  },
  computed: {
    ...mapState(['usuarioLogueado'])
  },
  created () {
    this.recuperarPedidos()
  }
}
</script>
